<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { article, name } = defineProps<{
    article: string;
    name: string;
  }>();
</script>

<template>
  <div class="parent-item">
    <Text>{{ article }}</Text>
    <Text font="body-regular-14" color="secondary">{{ name }}</Text>
  </div>
</template>

<style scoped>
  .parent-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px 0;
  }
</style>
